module.exports = __webpack_public_path__ + "img/discover.14522b42.svg";